import { mergeSxStyle } from '../../common/mergeSxStyle';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { skeletonDefaultStyle } from './skeletonDefaultStyle';
import { Skeleton as MuiSkeleton } from '@mui/material';

/**
 * Base Skeleton Loader
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const Skeleton = props => {
  const {
    children,
    variant,
    sx,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const skeletonStyle = mergeSxStyle(skeletonDefaultStyle(theme, variant), sx);
  const _getSize = (_variant, variable) => {
    if (_variant.type === 'circular') {
      return _variant.size;
    }
    if (_variant.type === 'rectangular' || _variant.type === 'rounded') {
      return _variant[variable];
    }
    return;
  };
  const _width = _getSize(variant, 'width');
  const _height = _getSize(variant, 'height');
  return /*#__PURE__*/_jsx(MuiSkeleton, {
    animation: 'pulse',
    variant: variant.type,
    width: _width,
    height: _height,
    sx: skeletonStyle,
    "data-testid": rest['data-testid'],
    children: children
  });
};